import { CommonModule, NgIf, NgFor } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewEncapsulation, AfterViewInit, ChangeDetectorRef, } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { FooterComponent } from '../footer/footer.component';
import { PartnersComponent } from '../partners/partners.component';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { GoogleMapsModule } from '@angular/google-maps';
import { IAlert, IFeasibility, IPackages } from 'app/core/shared-services/interfaces.types';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { FuseCardComponent } from '@fuse/components/card';
import { FuseLoadingService } from '@fuse/services/loading';
import { FuseSplashScreenService } from '@fuse/services/splash-screen';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { GtmDataLayerEvent } from 'app/core/shared-services/gtm/gtm.events';
import { SHOW_PACKAGES_PLAN_TYPE_MODAL_KEY, clearVettingStateInSession, packagesListHasBothPlanTypes } from 'app/core/constants/packages-flow.constants';


declare var $: any;

@Component({
  selector: 'landing-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgFor, SharedMethodsModule, MatButtonModule, NgIf,
    GoogleMapsModule, FooterComponent, MatProgressSpinnerModule, RouterLink,
    MatIconModule, MatInputModule, MatAutocompleteModule, FormsModule, CommonModule, FuseAlertComponent, PartnersComponent, FuseCardComponent],
})


export class LandingHomeComponent implements OnInit, AfterViewInit {

  @Output() alertNotification = new EventEmitter<IAlert>();

  public isLoggedIn: boolean;

  public location: HTMLElement;
  public selectedPlace: any;
  public mapCenter: { lat: number, lng: number };
  public showAlert: boolean = false;
  public alert: { type: FuseAlertType; message: string };
  private coords: any;
  private customer: any
  private LeadEntityID: number;
  public packagesFound: boolean = true;
  public spinner: boolean = false;
  public headerImage: string;
  public headerTitle: string;
  public headerBody: string;
  public featuredImage: string;
  public testimonials: any;
  public showDropDownAlert: boolean = false;
  public loading: boolean = false;
  public checkCoverageButton: any;


  // shared method results
  private feasibilityResult: IFeasibility;
  private feasibility: any;
  public packagesResult: IPackages;
  private packages: any;

  /**
   * Constructor
   */
  constructor(
    private _sharedMethods: SharedMethodsModule,
    private router: Router,
    private _webStorage: WebStorage,
    private changeDetector: ChangeDetectorRef,
    private activatedRouter: ActivatedRoute,
    private _fuseLoadingService: FuseLoadingService,
    private _fuseSplashService: FuseSplashScreenService,
    private _gtmService: GtmService
  ) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ On Init
  // ----------------------------------------------------------------------------------------------------- 


  async ngOnInit() {

    this.checkCoverageButton = document.querySelector("checkCoverageBtn");

    this._gtmService.trackPageView(undefined, undefined, GtmDataLayerEvent.PageView);
    
    sessionStorage.removeItem('SalesAgent');
    sessionStorage.removeItem("ActivePage");

    // try getting users location
    navigator.geolocation.getCurrentPosition(res => {
      this.coords = res?.coords;

      this.mapCenter = {
        lat: res?.coords?.latitude,
        lng: res?.coords?.longitude
      };
    })

    if (sessionStorage.getItem('accessToken')) {
      this.customer = await this._sharedMethods.getCustomerAccount();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      $('.slick-carousel').slick({
        // autoplay: true,
        // autoplaySpeed: 2000,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      });

      const input = document.getElementById('searchTextField') as HTMLInputElement;
      if (input) {
        this.getPlaceAutocomplete();
      }
    }, 1000);
  }


  /** 
   * On check
   */
  ngDoCheck(): void {
    if (sessionStorage.getItem('accessToken')) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
  }

  ngOnDestroy(): void {
    this.spinner = false;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Track Login/Sign in click (GTM) when user clicks from homescreen.
   */
  onLoginClick(clickText: string = 'Sign in'): void {
    this._gtmService.trackLoginClick(clickText);
  }

  /**
   * Get Places AutoComplete
   */

  public getPlaceAutocomplete() {
    sessionStorage.removeItem("installationComplete")
    // New address search starts a new journey — the previous lead's vetting no longer applies.
    clearVettingStateInSession();

    sessionStorage.removeItem("LeadEntityID");
    sessionStorage.removeItem("cartInfo");
    sessionStorage.removeItem("AvailablePackages");
    this._webStorage.CartInfo.next(0);
    this._webStorage.StoredLead.next(0);

    const input = document.getElementById('searchTextField') as HTMLInputElement;

    if (input) {
      const sessionToken = new google.maps.places.AutocompleteSessionToken();
      const options = {
        componentRestrictions: { country: 'ZA' },
        types: ['geocode', 'establishment',],
        fields: ['formatted_address', 'address_components', 'geometry'],
        sessionToken: sessionToken
      }
      const autocomplete = new window.google.maps.places.Autocomplete(input, options);

      google.maps.event.addListener(autocomplete, 'place_changed', () => {

        const place = autocomplete.getPlace();
        this.selectedPlace = place;
        this.showDropDownAlert = false;
        

      });

    }
  }

  /**
  ** Get using my location
  **/

  public async getLocation() {
    sessionStorage.removeItem("installationComplete")
    // New address search starts a new journey — the previous lead's vetting no longer applies.
    clearVettingStateInSession();

    sessionStorage.removeItem("LeadEntityID");
    sessionStorage.removeItem("cartInfo");
    sessionStorage.removeItem("AvailablePackages");
    this._webStorage.CartInfo.next(null);
    this._webStorage.StoredLead.next(0);
    navigator.geolocation.getCurrentPosition(res => {
      this.coords = res.coords;
      this.mapCenter = {
        lat: res.coords.latitude,
        lng: res.coords.longitude
      };
    });

    this.feasibility = await this._sharedMethods.geoCode(this.coords, null);

    if (this.feasibility.success) {


      this.feasibilityResult = this.feasibility.result;
      this.LeadEntityID = this.feasibilityResult.LeadEntityID;
      this._webStorage.StoredLead.next(this.LeadEntityID);
      // sets the required info and checks interface
      if (this.feasibilityResult.Feasibility == 'Yes' || this.feasibilityResult.Feasibility == 'Maybe') {

        // feasibility is 'Yes' and values are set, now retrieve packages
        this.packages = await this._sharedMethods.getAvailablePackages(this.LeadEntityID);

        if (this.packages.success) {

          this.packagesResult = this.packages.result;
          // //console.log("Packages success " + this.packagesResult);

          const pkgList = Array.isArray(this.packagesResult) ? this.packagesResult : [];
          if (packagesListHasBothPlanTypes(pkgList)) {
            sessionStorage.setItem(SHOW_PACKAGES_PLAN_TYPE_MODAL_KEY, '1');
          }
          this._webStorage.StorePackages(this.packagesResult);
          this.router.navigateByUrl('/packages').then(() => {
            this._fuseSplashService.hide();
          })
        }
      } else {
        this.loading = false
        this._fuseSplashService.hide();
        this.router.navigateByUrl('/packages').then(() => {
          this._fuseSplashService.hide();
        })

      }
    }
  }

  public checkCoverageBtn_onClick() {
    if (!this.selectedPlace) {
      this.showDropDownAlert = true;
      return;
    }

    this._gtmService.trackCheckCoverageClick();

    this.invokeEvent(this.selectedPlace);
  }





  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Invoke event
   */

  private invokeEvent(place: any) {
    this.loading = true;

    this._webStorage.SetCustomerGoogleAddress(place);
    const addressLabel = typeof place === 'string' ? place : (place?.formatted_address ?? '');
    sessionStorage.setItem('CustomerAddress', addressLabel);

    this.doGeocode(null, place);

  }

  private async doGeocode(coords?: { latitude: number, longitude: number }, place?: string) {

    this.feasibility = await this._sharedMethods.geoCode(coords, place);

      
      if (this.feasibility.success) {
      this.feasibilityResult = this.feasibility.result;
      this.LeadEntityID = this.feasibilityResult.LeadEntityID;
      this._webStorage.StoredLead.next(this.LeadEntityID);
      // sets the required info and checks interface
      if (this.feasibilityResult.Feasibility == 'Yes' || this.feasibilityResult.Feasibility == 'Maybe') {

        // feasibility is 'Yes' and values are set, now retrieve packages
        this.packages = await this._sharedMethods.getAvailablePackages(this.LeadEntityID);

        // //console.log(this.packages);

        if (this.packages.success) {
          this.packagesResult = this.packages.result;
          // //console.log(this.packagesResult);
          const pkgList = Array.isArray(this.packagesResult) ? this.packagesResult : [];
          if (packagesListHasBothPlanTypes(pkgList)) {
            sessionStorage.setItem(SHOW_PACKAGES_PLAN_TYPE_MODAL_KEY, '1');
          }
          this._webStorage.StorePackages(this.packagesResult);
          this.router.navigateByUrl('/packages').then(() => {
            this._fuseSplashService.hide();
          })
        }
      } else {
        this.loading = false;
        this.router.navigateByUrl('/packages').then(() => {
          this._fuseSplashService.hide();
        })
        

      }
    }
    else{
      this.alert = {
        type   : 'error',
        message: this.feasibility.error.error.Message
      };
    this.showAlert = true;
    this.loading = false;
    }
    
  }


}
